import { DEFAULT_ANNOTATION_LAYER } from "@/store/constants";

// Types
export const SET_CANVAS_DIMS = "SET_CANVAS_DIMS";
export const SET_FORCE_RIGHT_BAR = "SET_FORCE_RIGHT_BAR";


// models
const models = {};

// initial state
const state = () => ({
  defaultUsername: "User",
  forceRightBar: false,
  canvasDims: {
    height: 1040,
    width: 735,
  }
})

// getters
const getters = {
  getDefaultUsername: state => state.defaultUsername,
  getCanvasDims: state => ({ canvasDims: { ...state.canvasDims } }),
  getForceRightBar: state => state.forceRightBar,
}

// actions
const setCanvasDims = ({ commit }, { width, height }) => {
  commit(SET_CANVAS_DIMS, { width, height });
};

const setForceRightBar = ({ commit }, force) => {
  commit(SET_FORCE_RIGHT_BAR, force);
}



const actions = {
  setCanvasDims,
  setForceRightBar,
}

// mutations
const mutations = {
  [SET_CANVAS_DIMS](state, { width, height }) {
    state.canvasDims.height = height;
    state.canvasDims.width = width;
  },
  [SET_FORCE_RIGHT_BAR](state, force) {
    state.forceRightBar = force;
  },
  

}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  models
}